export const name = 'rank';

export const types = {
    GET_RANKS: `${name}/GET_RANKS`,
    GET_RANK: `${name}/GET_RANK`,
    GET_AREA: `${name}/GET_AREA`,
    GET_DISPATCH_GROUP: `${name}/GET_DISPATCH_GROUP`,
    CREATE_RANK: `${name}/CREATE_RANK`,
    UPDATE_RANK: `${name}/UPDATE_RANK`,
    DELETE_RANK: `${name}/DELETE_RANK`,
};
